module.exports = __webpack_public_path__ + "static/media/startTour.643c436d.png";